var render = function () {
  var _vm$currentRound$imag, _vm$currentRound$imag2, _vm$currentRound$imag3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-wrapper', [_vm.currentRound.image ? _c('section', {
    staticClass: "imageSection"
  }, [_c('img', {
    staticClass: "topImage",
    attrs: {
      "src": (_vm$currentRound$imag = (_vm$currentRound$imag2 = _vm.currentRound.image) === null || _vm$currentRound$imag2 === void 0 ? void 0 : _vm$currentRound$imag2.image.src) !== null && _vm$currentRound$imag !== void 0 ? _vm$currentRound$imag : '',
      "alt": (_vm$currentRound$imag3 = _vm.currentRound.image) === null || _vm$currentRound$imag3 === void 0 ? void 0 : _vm$currentRound$imag3.image.description
    }
  })]) : _vm._e(), _c('section', {
    staticClass: "questionSection"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound && _vm.currentRound.questionHtml
    }
  })], 1), _vm.currentRound && _vm.currentRound.textHtml ? _c('section', {
    staticClass: "htmlSection"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.textHtml,
      "onClick": _vm.maybeClickHandler,
      "getTextClass": _vm.getTextClass
    }
  })], 1) : _vm._e(), _vm.showActivityNextSectionPortal ? _c('activity-next-section-portal', {
    attrs: {
      "handleOnActivitySubmit": _vm.handleOnActivitySubmit,
      "displayWrongIcon": _vm.displayWrongIcon,
      "displayCorrectIcon": _vm.displayCorrectIcon
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }